<template>
    <v-layout class="consent-wrapper TextUnderCkBox">
        <v-flex class="pa-2">
            <span
                class="hint"
                v-text="$t('form.phxCovidScreeningDetailsConsentHint')"
            />
            <ul class="list-items">
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint1')"
                    />
                </li>
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint2')"
                    />
                </li>
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint3')"
                    />
                </li>
            </ul>
            <v-layout column>
                <v-checkbox
                    hide-details
                    :input-value="value"
                    color="primary"
                    :rules="[(v) => !!v || $t('form.errors.piConsentRequired')]"
                    :name="metadata.name"
                    :data-meta-id="metadata.id"
                    :id="metadata.name"
                    @change="emitValueCheckbox1"
                >
                    <template slot="label">
                        <span class="body-2" v-html="(required ? '* ' : '') + $t('form.phxCovidScreeningDetailsConsentLabel')" />
                    </template>
                </v-checkbox>

                <v-checkbox
                    v-if="getStatusForAcceptRisk"
                    class="body-2 piConsent"
                    hide-details
                    :value="valueForAcceptRisk"
                    color="primary"
                    role="checkbox2"
                    :rules="[(v) => !!v || $t('form.errors.piConsentRequired')]"
                    :data-meta-id="metadata.id"
                    :id="metadata.name"
                    @change="emitValueCheckbox2"
                >
                    <template slot="label">
                        <span class="body-2" v-html="(required ? '* ' : '') + phxCovidAcceptRiskLabel" />
                    </template>
                </v-checkbox>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { MetadataEnum } from '@/enums';
import { find, replace } from 'lodash';

export default {
    name: 'phx-covid-screening-details-consent',
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: true },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            consentLink: 'https://static.trimoz.com/clicsante/documents/Consentement_limites_risques.pdf',
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        valueForAcceptRisk() {
            const findMetaData = this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_ACCEPT_RISK]);
            return findMetaData && findMetaData.value;
        },
        phxCovidAcceptRiskLabel() {
            return replace(this.$t('form.phxCovidAcceptRiskLabel'), /%consentDomain%/g, this.consentLink);
        },
        getStatusForAcceptRisk() {
            const acceptRisk = find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_ACCEPT_RISK]);
            if (acceptRisk) {
                return acceptRisk.status === 1;
            }
            return !!acceptRisk;
        },
    },
    methods: {
        emitValueCheckbox1(value) {
            this.$emit('updateOtherMetadata', {
                metadata: this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_SCREENING_DETAILS_CONSENT]),
                value,
            });
        },
        emitValueCheckbox2(value) {
            this.$emit('updateOtherMetadata', {
                metadata: find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_ACCEPT_RISK]),
                value,
            });
        },
    },
};
</script>

<style lang="scss">
.TextUnderCkBox {
  border: 2px solid var(--v-primary-base)!important;
  border-radius: 4px!important;
  padding: 1rem;
  background: rgba(255,255,255,1);
  color: rgba(0, 0, 0, 0.54);
  margin-top: 1rem;
  margin-bottom: 1rem;

    .piConsent label {
      font-size: 14px;
    }

    .list-items li {
      font-size: 14px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.84);
    }

    .list-items {
      margin-left: 30px;
      margin-top: 10px;
      list-style-type: disc;
      margin-bottom: 10px;
    }

    .consent-wrapper {
      margin-top: 20px;
    }

    .row {
      display: flex;
      font-size: 14px;
    }

    strong {
        font-weight: bold !important;
    }
}
</style>
